module.exports = __webpack_public_path__ + "img/edukanji-demo.6e1be0f4.png";